<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ 'Mã đặt phòng' }}</div>
                <input v-model="searchParams.recode" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.roomLevel') }}</div>
                <el-select
                  v-model="searchParams.roomLevelId"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in roomLevelList"
                    :key="item.id"
                    :label="`(${item.code}) - ${item.name}`"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelId"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.guestDepatureReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />

              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              dom-layout="scroll"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Nguồn: nguồn của đặt phòng</li>
            <li>Hạng phòng: hiển thị tên hàng phòng và số phòng</li>
            <li>Ngày đến: ngày đến của đặt phòng</li>
            <li>Ngày đi: ngày đi của đặt phòng</li>
            <li>
              Số đêm: Số đêm được tính từ ngày khách đến đến ngày khách đi
            </li>
            <li>Số khách: số khách của đặt phòng</li>
            <li>Tên khách: Tên khách đặt phòng</li>
            <li>Số điện thoại khách: số điện thoại của khách đặt phòng</li>
            <li>
              Doanh thu sau khi giảm giá: Doanh thu phòng + Phí dịch vụ - Giảm
              giá
            </li>
            <li>Đã cọc: số tiền khách đã cọc</li>
            <li>
              Cần thu: số tiền còn lại cần phải thu = Doanh thu sau khi giảm giá
              - đặt cọc
            </li>
            <li>
              Hiển thị tổng số phòng, Khách, doanh thu: tổng của các ngày trong
              khoảng thời gian tìm kiếm
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import Multiselect from 'vue-multiselect'
import { getAllHotel } from '@/api/hotel.js'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import InfoBtn from './components/InfoBtn.vue'
import {
  getDepartGuestReportApi,
  getDepartGuestReportExcel
} from '@/api/report_service/report'
import moment from 'moment'

const cellStylesPinnedBottom = {
  minWidth: '200px',
  overflow: 'visible',
  zIndex: 1,
  fontWeight: 700
}

const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelId: null,
  recode: null,
  roomLevelId: null
})

export default {
  components: {
    DasButton,
    // eslint-disable-next-line vue/no-unused-components
    Multiselect,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      selectValueArray2: [],

      gridLoading: false,
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      receptionistOptions: [],
      roomLevelList: [],
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      columns: [
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_code',
          tooltipField: 'source_code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_cd',
          tooltipValueGetter: params => {
            if (!params.data.is_bottom) {
              return params.value
            } else {
              return `${this.$t('variables.totalNumOfRoom')}: ${params.value}`
            }
          },
          cellRenderer: params => {
            if (!params.data.is_bottom) {
              return params.value
            } else {
              return `${this.$t('variables.totalNumOfRoom')}: ${params.value}`
            }
          },
          cellStyle: params => {
            if (params.data.is_bottom) {
              return cellStylesPinnedBottom
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          valueFormatter: params => {
            return params.value
              ? this.$moment(params.value?.slice(0, 11)).format('DD-MM-YYYY')
              : null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 120,

          sortable: false
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'depart_date',

          valueFormatter: params => {
            return params.value
              ? this.$moment(params.value?.slice(0, 11)).format('DD-MM-YYYY')
              : null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.numOfNight'),
          field: 'num_of_night',
          // cellClass: "grid-cell-centered",
          minWidth: 80,
          maxWidth: 80,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.numOfGuest'),
          field: 'num_of_guest',
          tooltipValueGetter: params => {
            if (!params.data.is_bottom) {
              return params.value
            } else {
              return `${this.$t('variables.totalNumOfGuest')}: ${params.value}`
            }
          },
          cellRenderer: params => {
            if (!params.data.is_bottom) {
              return params.value
            } else {
              return `${this.$t('variables.totalNumOfGuest')}: ${params.value}`
            }
          },
          cellStyle: params => {
            if (params.data.is_bottom) {
              return cellStylesPinnedBottom
            }
          },
          minWidth: 90,
          maxWidth: 90,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.customerName'),
          // field: 'col8',
          tooltipValueGetter: params => {
            if (!params.data.is_bottom) {
              return params.data.last_name + ' ' + params.data.first_name
            }
          },
          cellRenderer: params => {
            if (!params.data.is_bottom) {
              return params.data.last_name + ' ' + params.data.first_name
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.guestPhoneNum'),
          field: 'phone_number',
          tooltipField: 'phone_number',
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.revenueAfterDiscount'),
          field: 'revenue',
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          tooltipValueGetter: params => {
            if (!params.data.is_bottom) {
              return params.value
            } else {
              return `${this.$t('variables.totalRevenue')}: ${params.value}`
            }
          },
          cellRenderer: params => {
            const paramsValue =
              params.value !== null && params.value !== undefined
                ? Number(params.value).toLocaleString('en')
                : 0

            if (!params.data.is_bottom) {
              return paramsValue
            } else {
              return `${this.$t('variables.totalRevenue')}: ${paramsValue} `
            }
          },
          cellStyle: params => {
            if (params.data.is_bottom) {
              return {
                ...cellStylesPinnedBottom,
                minWidth: '250px'
              }
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.deposited'),
          field: 'deposit',
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.needToCollect'),
          field: 'need_to_collect',
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false
        }
      ],
      rows: [],
      pinnedBottomRowData: []
    }
  },
  computed: {
    recode() {
      return this.searchParams.recode
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.hotelId = []
          this.searchParams.roomLevelId = null
          // this.searchParams.saleAgentId = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  beforeMount() {},
  async mounted() {
    await this.getHotelOptions()
    this.getRoomLevelOptions()
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmd) {
      if (cmd === 'excel') {
        getDepartGuestReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'guest_depart_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    attachData() {
      getDepartGuestReportApi(this.searchParams).then(res => {
        this.rows = res.data
        this.pinnedBottomRowData = [
          {
            num_of_guest: res.map.total_guest,
            room_level_cd: res.map.total_room,
            revenue: res.map.total_revenue,
            is_bottom: true
          }
        ]
      })
    }
  }
}
</script>
